<div class="container">
    <div [innerHTML]="info"></div>
</div>
